export default __webpack_public_path__ + "images/0cedb9a89f541dd7dab437240d12d5b6-mc@2x.png";